import React from 'react'
import { IconClose, IconEwiWarningTriangle } from 'components/Zui/Icon'
import { useIntl } from 'hooks'
import { StateLabel, ScrollableDirective, InlineMessage } from 'components/Zui'

const EmailsList = ({ data, handleDeleteMail }) => {
    const { t } = useIntl()
    return (
        <div style={{ display: 'flex', flexFlow: 'column', gap: '10px' }}>
            <div className="share-pill-item-wrapper">
                <ScrollableDirective
                    style={{
                        maxHeight: '185px',
                        width: '100%',
                        flexGrow: '1',
                        overflow: 'auto',
                    }}
                >
                    {data.map(user => {
                        return (
                            <div className="share-pill-item" key={user.email}>
                                <div> {user.email} </div>

                                <div className="share-pill-item-right">
                                    {user.isNew && (
                                        <div className="state-wrapper">
                                            <StateLabel state="ready">
                                                <span>{t('state.added')}</span>
                                            </StateLabel>
                                        </div>
                                    )}
                                    {user.canRevoke && (
                                        <div>
                                            <IconClose
                                                size="s"
                                                onClick={() => handleDeleteMail(user.email)}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        )
                    })}
                </ScrollableDirective>
            </div>
            {data.length > 0 && (
                <div className="annonymized-message">
                    <InlineMessage>
                        {t('disclaimer.settings.text')}
                        <IconEwiWarningTriangle slot="icon" />
                    </InlineMessage>
                </div>
            )}
        </div>
    )
}

export default EmailsList
